type Props = {
  children: React.ReactNode;
  styles?: string;
};

export default function Paragraph({ children, styles }: Props) {
  return <p className={`mb-4 ${styles}`}>{children}</p>;
}
